<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<div class="d-f jc-sb ai-c mb-xxs" *ngIf="!loading">
	<button mat-stroked-button color="primary" [matMenuTriggerFor]="filter">
		<mat-icon svgIcon="sanus-filter-blue"></mat-icon>
		<span class="no-mob">Filtrar</span>
	</button>
	<mat-menu #filter="matMenu">
		<button mat-menu-item (click)="activeFilter = 1">Todos os parceiros</button>
		<button mat-menu-item (click)="activeFilter = 2">
			Parceiros de plano de saúde
		</button>
		<button mat-menu-item (click)="activeFilter = 3">
			Parceiros de plano dentais
		</button>
	</mat-menu>
	<button mat-flat-button color="primary" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo parceiro</span>
	</button>
</div>
<div class="d-f jc-fs" *ngIf="!loading && !partners.length">
	<p class="fs-xs lh-xs fs-i gray">Nenhum parceiro cadastrado</p>
</div>
<ng-container *ngIf="!loading && partners.length">
	<div
		class="{{
			shouldDisplayPartner(partner) ? '' : 'd-n'
		}} pos-r mb-xxxs pb-nano br-md card"
		*ngFor="let partner of partners; let index = index"
	>
		<div class="d-f ai-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f fd-c jc-c col">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Parceiro</span>
				<span class="mt-quark fs-xs lh-xs to-ellipsis">
					{{ partner.name_secondary }}
				</span>
			</div>
			<div class="d-f fd-c jc-c col no-mob">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Cidade/estado</span>
				<span class="mt-quark fs-xs lh-xs">
					{{ partner.city ?? '-' }}/{{
						partner.state ? (partner.state | statelabel) : '-'
					}}
				</span>
			</div>
			<div class="d-f jc-c col no-mob">
				<span class="fs-xxs lh-xxs fw-bold chip" *ngIf="partner.dental_plan">
					Dental
				</span>
				<span
					class="{{
						partner.dental_plan ? 'ml-nano' : ''
					}} fs-xxs lh-xxs fw-bold chip"
					*ngIf="partner.health_plan"
				>
					Saúde
				</span>
			</div>
			<div class="d-f jc-c ai-c mr-nano c-p squared" [matMenuTriggerFor]="menu">
				<mat-icon svgIcon="sanus-more-blue"></mat-icon>
			</div>
		</div>
		<div class="d-f mb-quark ml-xxxs mob">
			<span class="fs-xxs lh-xxs fw-bold chip" *ngIf="partner.dental_plan">
				Dental
			</span>
			<span
				class="{{
					partner.dental_plan ? 'ml-nano' : ''
				}} fs-xxs lh-xxs fw-bold chip"
				*ngIf="partner.health_plan"
			>
				Saúde
			</span>
		</div>
		<mat-menu #menu="matMenu">
			<button mat-menu-item (click)="onEditPartner(partner.id)">
				Editar parceiro
			</button>
		</mat-menu>
	</div>
	<div class="pb-huge">&nbsp;</div>
</ng-container>
